import {BarActions, OBarActionsInit} from "/@back@/commons/widgets/bars.js";
import {Button, OButtonInit} from "/@back@/commons/widgets/buttons.js";
import {CellBuilderIconLabel} from "/@back@/commons/widgets/grid-libs.js";
import {GridSmall, OGridSmallInit} from "/@back@/commons/widgets/grid-tags.js";
import {GridColTreeDef, GridDataHolderJsonTree, GridDataRowJsonTree} from "/@back@/commons/widgets/tree.js";
import {SrcDrawer, SrcPointerDblClick, SrcPointerFastSelect, SrcPointerInline} from "/@back@/wsp/widgets/srcDrawer.js";
import {FORMS, IFormJsonisable, MxFormElement, OFormElementInit} from "/@lib@/commons/forms.js";
import {IInfo, IInfoConsumer} from "/@lib@/commons/infos.js";
import {ILastDatasBuilder, JLastDatas, LASTDATAS} from "/@lib@/commons/lastDatas.js";
import {IReg, IRegPointer, REG} from "/@lib@/commons/registry.js";
import {SEC} from "/@lib@/commons/security.js";
import {render, TemplateResult, xhtml} from "/@lib@/commons/utils/htmlLit.js";
import {BaseAreaView, IView, IViewApi, IViewContainer, IViewsContainer, OBaseAreaViewInit, OViewVisitOptions} from "/@lib@/commons/views.js";
import {DOM, JSX} from "/@lib@/commons/xml/dom.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {InfoCurrentItem, InfoReqCurrentItem, ITEM, JGenInfo, JGenSkin} from "/@lib@/wsp/item.js";
import {JSrcFields, SRC, srcRef} from "/@lib@/wsp/src.js";
import {IWspUiEnv, JWspUriChangeMsg, JWspWorkingInitStates, Wsp, wspUri} from "/@lib@/wsp/wsp.js";
import {IDatasItemCidNode, IItemPubNode, IPubCtx} from "/@lib@/wsp/wspMetaUi.js";
import {EventMgr} from "/@lib@/commons/events.js";
import {CID, CidManifest, CidProcess, CidSession, CidStep, CidWebAuthStep, ECidSessionState, ICidManifestPointer, ICidStepResult, ICidUiHandler} from "/@lib@/core/cid.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {BaseElement, MsgLabel} from "/@back@/commons/basis.js";
import {JWspGenMsg} from "/@back@/wsp/views/gen/genActions.js";
import {DynGen, IWindowDynGen, ODynGenInit} from "/@back@/wsp/views/dynGen.js";
import {AREAS, IArea, IControlAreaContext} from "/@lib@/commons/areas.js";
import {UiThemeDeskFeat} from "/@back@/core/plugins/optionsPlg.js";
import {IAction} from "/@lib@/commons/actions.js";
import {IWbToolLocatedArea} from "/@back@/core/widgets/workbench.js";
import {IO} from "/@lib@/commons/io/io.js";
import {ERROR} from "/@lib@/core/errorReport.js";
import {EWspChangesEvts, WspsLivePlace} from "/@lib@/wsp/wspsLive.js";


/**
 */
export interface GeneratorTabs extends BaseAreaView<IRegPointer<IWspUiEnv>> {
	initialize(init: OGeneratorTabsInit): this
}


export interface OGeneratorTabsInit extends OGeneratorsInit {
	lastDatas?: JLDGeneratorTabs,
}

export class GeneratorTabs extends BaseAreaView<IRegPointer<IWspUiEnv>> implements IInfoConsumer, ILastDatasBuilder, IViewsContainer {
	reg: IReg<IWspUiEnv>;
	wsp: Wsp;

	/** Tab non figé, qui suit l'item courant via l'infoBroker. */
	liveTab: GeneratorTab;

	/** Tab actuellement actif. */
	currentTab: GeneratorTab;

	genTabs: HTMLElement;
	gens: Generators;

	/** Uri de destinatiob libre. Usage : styler */
	customDestPath?: wspUri;

	protected pubNodeMatchFilter?: (pubNode: IItemPubNode) => boolean;

	protected _initialize(init: OGeneratorTabsInit) {
		super._initialize(init); //init this.reg, this.area, this.areaContext
		this.wsp = this.reg.env.wsp;
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this._initAndInstallSkin(this.localName, init);
		//this.setAttribute("layout", (init.area as IWbToolLocatedArea)?.layout || 'h');
		this.pubNodeMatchFilter = init.pubNodeMatchFilter;

		this.genTabs = sr.appendChild(<c-arrow-scroll-box id="tabs"/>);
		this.genTabs.onkeydown = function (this: HTMLElement, ev: KeyboardEvent) {
			switch (ev.code) {
			case 'ArrowLeft' : {
				const genView = DOMSH.findHost<GeneratorTabs>(this);
				const tab = genView.currentTab.tab.previousElementSibling as IGeneratorTabPointer; //TODO RTL
				if (tab) tab.genTab.tab.genTab.itemPtr.focus();
				break;
			}
			case 'ArrowRight' : {
				const genView = DOMSH.findHost<GeneratorTabs>(this);
				const tab = genView.currentTab.tab.nextElementSibling as IGeneratorTabPointer;
				if (tab) tab.genTab.tab.genTab.itemPtr.focus();
				break;
			}
			default:
				return;
			}
			ev.stopPropagation();
			ev.preventDefault();
		};

		this.genTabs.ondragover = function (this: HTMLSpanElement, ev: DragEvent) {
			ev.preventDefault();
			ev.stopImmediatePropagation();
			const me = DOMSH.findHost<GeneratorTabs>(this);
			const shortDescs = ITEM.getShortDescsTransferFromDragSession(me.reg, ev.dataTransfer, {targetSrcType: "item"}, this);
			//on autorise le drop si item local
			ev.dataTransfer.dropEffect = !shortDescs || shortDescs.srcRefs.length < 1 || shortDescs.wspCd !== me.reg.env.wsp.code ? "none" : "link";
		};
		this.genTabs.ondrop = function (this: HTMLSpanElement, ev: DragEvent) {
			ev.preventDefault();
			ev.stopImmediatePropagation();
			const me = DOMSH.findHost<GeneratorTabs>(this);
			const shortDescs = ITEM.getShortDescsTransferFromDragSession(me.reg, ev.dataTransfer, {targetSrcType: "item"}, this);
			if (!shortDescs || shortDescs.isImport || shortDescs.srcRefs.length < 1 || shortDescs.wspCd !== me.reg.env.wsp.code) return;
			me.setCurrentTab(new GeneratorTab(me, false, {srcRef: shortDescs.srcRefs[0]}));
		};

		this.gens = sr.appendChild(new Generators().initialize(init)) as Generators;
		this.gens.onCodePubChange.add(function (gens: Generators) {
			const me = DOMSH.findHost<GeneratorTabs>(gens);
			if (me.currentTab) {
				me.currentTab.codePub = me.gens.codePub;
				if (me.currentTab.pinned) me.saveTabs();
			}
		});

		if (this.reg.env.infoBroker) this.reg.env.infoBroker.addConsumer(this);
		this.reg.env.place.eventsMgr.on("onConnectionRenewed", () => {this.refreshStates()}); //on ne gère pas le désabonnement, considérant que la view est stable avec la place courante.
		this.liveTab = new GeneratorTab(this, true);
		this.genTabs.appendChild(<Button id="addTab" onclick={this.onAddTab} tabindex-custom="-1" icon="/@skin@/wsp/views/generators/addtab.svg" ui-context="bar"
																		 title="Ajoute un onglet pour un accès stable aux publications d'un item"/>);
		this.setCurrentTab(this.liveTab);
		this.lastDatas = init.lastDatas;
	}

	setCurrentTab(genTab: GeneratorTab) {
		if (this.currentTab) this.currentTab.setAsCurrentTab(false);
		this.currentTab = genTab;
		this.currentTab.setAsCurrentTab(true);
		this.gens.setSrc(genTab.itemPtr.shortDescs[0], genTab.codePub);
	}

	buildLastDatas?(parentLastDatas: JLastDatas): void {
		const lastDatasKey = this.getAttribute('last-datas');
		if (lastDatasKey) {
			const ld = this.makeLastDatas();
			if (ld) parentLastDatas[lastDatasKey] = ld;
		}
	}

	protected makeLastDatas(): JLDGeneratorTabs | null {
		if (this.currentTab !== this.liveTab) {
			//Un onglet figé est sélectionné, on le mémorise
			const srcRef = this.currentTab.itemPtr.srcRef;
			if (srcRef) return {currTab: {srcRef, codeGen: this.currentTab.codePub}};
		}
		return null;
	}

	async refreshStates() {
		await this.wsp.waitForAvailable(this);
		let tab = DOM.findFirstChild(this.genTabs, isGeneratorTabPointer);
		while (tab) {
			tab.genTab.itemPtr.fetchSrc();
			tab = DOM.findNextSibling(this.genTabs, isGeneratorTabPointer);
		}
	}

	async onAddTab(this: Button, ev: MouseEvent) {
		const me = DOMSH.findHost<GeneratorTabs>(this);
		const genTab = new GeneratorTab(me, false, {srcRef: null});
		me.setCurrentTab(genTab);
		await SrcPointerFastSelect.SINGLETON.execute(genTab.itemPtr, ev);
		if (!genTab.itemPtr.srcRef) genTab.closeTab();
	}

	onInfo(info: IInfo): void {
		if (this.hidden) return;
		if (info instanceof InfoCurrentItem) this.liveTab.itemPtr.setSrcRef(info.srcUri, info.shortDesc);
	}

	onViewShown() {
		if (!this._onLiaiseMsg) {
			this._onLiaiseMsg = this.onLiaiseMsg.bind(this);
			this.reg.env.universe.wsFrames.ws.msgListeners.on('liaise', this._onLiaiseMsg);
		}
		if (!this._onConnRenewed) {
			this._onConnRenewed = this.onConnRenewed.bind(this);
			this.reg.env.place.eventsMgr.on("onConnectionRenewed", this._onConnRenewed);
		}
		this.gens.onViewShown();
		this.liveTab.refreshLiveTab();
		if (this.lastSaveDt === -2) this.fetchTabs();
	}

	visitViews(visitor: (view: IViewApi) => any, options?: OViewVisitOptions): any {
		return visitor(this.gens);
	}

	visitViewsAsync(visitor: (view: IViewApi) => Promise<any>, options?: OViewVisitOptions): Promise<any> {
		return visitor(this.gens);
	}

	findPinnedTab(srcRef: srcRef, codePub: string): GeneratorTab | null {
		let tab = DOM.findFirstChild(this.genTabs, isGeneratorTabPointer);
		if (this.liveTab === tab.genTab) tab = DOM.findNextSibling(tab, isGeneratorTabPointer);
		while (tab) {
			if (tab.genTab.itemPtr.srcRef === srcRef && tab.genTab.codePub === codePub) return tab.genTab;
			tab = DOM.findNextSibling(tab, isGeneratorTabPointer)
		}
		return null;
	}

	protected onSyncLost() {
		if (!this.hidden) {
			//On est visible, on refresh
			this.fetchTabs();
		} else {
			//On est masqué, on marque l'état invalide.
			this.lastSaveDt = -2;
			this.lastSaved = null;
		}
	}

	/** Détection d'une écriture concurente via le service de liaise. */
	protected _onLiaiseMsg: (m: Jsonisable) => void;

	protected onLiaiseMsg(m: Jsonisable) {
		if (m.type === 'genTabs.saved' && m.uri === this.saveUri) this.onSyncLost();
	}

	protected _onConnRenewed: () => void;

	protected async onConnRenewed() {
		const resp = await this.wsp.wspServer.config.privateFolderUrl.fetch(IO.qs("cdaction", "GetSrc", "format", "JSON", "fields", "srcDt", "param", this.wsp.code, "refUri", "", "privateUri", this.saveUri), 'json');
		if (resp.status === 200 && resp.asJson ? this.lastSaveDt !== resp.asJson.srcDt : (resp.status === 404 && this.lastSaveDt !== -1)) this.onSyncLost();
	}

	protected saveUri = "/genTabs.json";
	/**
	 * -2 : pas encore initialisé (ou conn perdue)
	 * -1 : fichier inexistant soit aucun genTabs
	 *  0 : erreur au fetch
	 */
	protected lastSaveDt = -2;
	protected lastSaved: JGenTabsSaved;
	protected lastDatas?: JLDGeneratorTabs;

	async fetchTabs() {
		try {
			if (!this.wsp.isAvailable) await this.wsp.waitForAvailable(this);
			const resp = await this.wsp.wspServer.config.privateFolderUrl.fetch(IO.qs("cdaction", "GetSrc", "format", "stream", "fields", "srcDt", "param", this.wsp.code, "refUri", "", "privateUri", this.saveUri), 'json');
			if (resp.status === 200) {
				const savedTabs = resp.asJson as JGenTabsSaved;
				//console.log("savedSearch::::::::", this.srcDt, savedSearch);
				const lastCurr = (this.lastDatas || this.makeLastDatas())?.currTab
				this.lastDatas = null;
				do {
					//Cleanup des pinned tabs (en cas de resync)
					let tab = DOM.findLastChild(this.genTabs, isGeneratorTabPointer);
					if (!tab || this.liveTab === tab.genTab) break;
					tab.remove();
				} while (true);
				if (savedTabs?.tabs) for (const tabDef of savedTabs.tabs) new GeneratorTab(this, false, tabDef);
				if (lastCurr) {
					const tab = this.findPinnedTab(lastCurr.srcRef, lastCurr.codeGen);
					if (tab) this.setCurrentTab(tab);
				}
				this.lastSaved = savedTabs;
				this.lastSaveDt = (JSON.parse(resp.headers.get("X-SCFIELDS")) as JSrcFields).srcDt;
			} else {
				this.lastSaved = null;
				this.lastSaveDt = resp.status === 404 ? -1 : 0;
			}
		} catch (e) {
			this.lastSaved = null;
			this.lastSaveDt = 0;
			ERROR.log("fetchSearches failed", e);
		}
	}

	async saveTabs() {
		if (this.lastSaveDt === -2) return;
		try {
			const tabs: JLDGeneratorTab[] = [];
			let tab = DOM.findFirstChild(this.genTabs, isGeneratorTabPointer);
			if (this.liveTab === tab.genTab) tab = DOM.findNextSibling(tab, isGeneratorTabPointer);
			while (tab) {
				const srcRef = tab.genTab.itemPtr.srcRef;
				const codeGen = tab.genTab.codePub;
				if (srcRef && codeGen) tabs.push({srcRef, codeGen} as JLDGeneratorTab); //On enregistre que des onglets complets avec src et codePub.
				tab = DOM.findNextSibling(tab, isGeneratorTabPointer)
			}
			if (!this.isTabsChanged(tabs)) return;
			//console.log(":saveGenTabs::::", tabs);
			const backup = this.lastSaved;
			try {
				this.lastSaved = {tabs} as JGenTabsSaved; //avant l'enreg async pour un saveTabs() concurrent identique.
				const fields = await this.wsp.wspServer.config.privateFolderUrl.fetchJson<JSrcFields>(IO.qs("cdaction", "PutSrc", "format", "JSON", "fields", "srcDt", "param", this.wsp.code, "refUri", "", "privateUri", this.saveUri), {
					method: "POST",
					body: JSON.stringify(this.lastSaved),
					headers: {"Content-Type": "application/json"}
				});
				this.lastSaveDt = fields.srcDt;
			} catch (e) {
				this.lastSaved = backup;
				throw e;
			}
			this.reg.env.universe.wsFrames.ws.postMsg({svc: 'liaise', type: "genTabs.saved", uri: this.saveUri})
		} catch (e) {
			ERROR.log(`Save gen tabs to '${this.saveUri}' failed`, e);
		}
	}

	protected isTabsChanged(tabs: JLDGeneratorTab[]) {
		if (this.lastSaveDt === -2) return false; //pas encore init
		if (this.lastSaveDt === -1) return tabs.length > 0;
		if (!this.lastSaved) return true;
		const old = this.lastSaved.tabs;
		if (old?.length !== tabs.length) return true;
		for (let i = 0; i < tabs.length; i++) {
			if (tabs[i].srcRef !== old[i].srcRef || tabs[i].codeGen !== old[i].codeGen) return true;
		}
		return false;
	}
}

REG.reg.registerSkin("wsp-generator-tabs", 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
	}

	#tabs {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		margin-bottom: -1px;
	}

	#headTi {
		padding: 0 .3em;
		font-size: 80%;
		white-space: nowrap;
		color: var(--fade-color);
	}

	.genTab {
		display: flex;
		padding: 2px 4px;
		border-bottom: solid 2px transparent;
	}

	.genTab:first-of-type > wsp-src-pointer-inline.empty {
		display: none;
	}

	.genTab:first-of-type > wsp-src-pointer-inline.empty + .dupTab {
		display: none;
	}

	#addTab {
		border-inline: 1px solid var(--border-color);
		min-height: calc(6px + var(--icon-size))
	}

	.genTab.currentTab {
		border-color: var(--tabl-select-color);
		color: var(--tabl-select-color);
		-webkit-text-stroke: 0.5px var(--tabl-select-color);
	}

	.genTab:hover {
		background: var(--pressed-bgcolor);
	}

	wsp-generators {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		border-top: 1px solid var(--border-color);
	}
`);

customElements.define("wsp-generator-tabs", GeneratorTabs);


class GeneratorTab {
	tab: IGeneratorTabPointer;
	itemPtr: SrcPointerInline;
	btn: Button;
	codePub: string;
	pinned: boolean;
	/** Mémoire du listener des WspChanges pour delete. */
	protected _lstn: (msg: JWspUriChangeMsg, from: WspsLivePlace | 'local' | 'server') => void;

	constructor(public genView: GeneratorTabs, atFirst: boolean, lastDatas?: JLDGeneratorTab) {
		this.tab = genView.genTabs.insertBefore(<span class="genTab"/>, atFirst ? genView.genTabs.firstChild : null) as IGeneratorTabPointer;
		this.tab.genTab = this;
		this.itemPtr = this.tab.appendChild(new SrcPointerInline().initialize({
			reg: genView.reg,
			defaultAction: genView.reg.getSvc("ptrItemDblClick", SrcPointerDblClick.SINGLETON),
			sgnPattern: genView.reg.env.wsp.wspMetaUi.getGenOrCidSgnPattern(),
			showStatus: true,
			draggable: true,
			dropable: true,
			dispatchHighlight: true
		}));
		this.setPinState(lastDatas != null);
		this.itemPtr.classList.add("fixedIconSize");
		this.itemPtr.tabIndex = -1;
		this.itemPtr.addEventListener('focus', function (this: SrcPointerInline, ev: FocusEvent) {
			const genTab = (this.parentElement as IGeneratorTabPointer).genTab;
			genTab.genView.setCurrentTab(genTab);
		});
		if (genView.reg.env.place instanceof WspsLivePlace) {
			this._lstn = this.onWspUriChange.bind(this);
			genView.reg.env.place.eventsMgr.on('wspUriChange', this._lstn);
		}

		this.itemPtr.onSrcRefChange.add(function (drawer: SrcDrawer) {
			// NOTE : ce listener est complété de onWspUriChange. cf comment associé
			const genTab = (drawer.parentElement as IGeneratorTabPointer).genTab;
			const src = drawer.shortDescs[0];
			if (!src || src.srcSt < 0) {
				if (genTab.pinned) genTab.closeTab();
				else drawer.setSrcRef(null); //item supprimé, on efface le lien.
			} else if (genTab.pinned) genTab.genView.saveTabs();
			if (genTab.genView.currentTab === genTab) genTab.genView.gens.setSrc(src, genTab.codePub);
		});
		if (this.pinned) {
			this.codePub = lastDatas.codeGen;
			this.itemPtr.setSrcRef(lastDatas.srcRef);
			this.btn = this.tab.appendChild(this._newCloseButton("-1"));
		} else {
			this.btn = this.tab.appendChild(<Button class="dupTab" onclick={this.onPin} tabindex-custom="-1" icon="/@skin@/wsp/views/generators/duptab.svg" ui-context="bar"
																							title="Duplique cet onglet pour un accès stable aux publications de l'item"/>) as Button;
			this.refreshLiveTab();
		}
	}

	/**
	 * On complète le listener d'event de modification associé à `this.itemPtr.onSrcRefChange`
	 * pour réagir à tous les évents qui peuvent avoir une incidence sur les roles
	 * NOTE : le "itemPtr" reste responsable du dispatch aprés fetch via `onSrcRefChange`
	 * @param msg
	 * @param from
	 * @protected
	 */
	protected onWspUriChange(msg: JWspUriChangeMsg, from: WspsLivePlace | 'house' | 'server') {
		if (msg.wspCd !== this.itemPtr.reg.env.wsp.code)
			return;
		if (this.itemPtr.srcRef === SRC.srcRef(msg) && [EWspChangesEvts.u, EWspChangesEvts.perm, EWspChangesEvts.rspUsrs, EWspChangesEvts.lcSt].includes(msg.type)) {
			this.itemPtr.fetchSrc();
		}
	}

	setAsCurrentTab(current: boolean) {
		this.tab.classList.toggle('currentTab', current);
		this.itemPtr.tabIndex = current ? 0 : -1;
		this.btn.tabIndexCustom = current ? 0 : -1;
	}

	refreshLiveTab() {
		//on affecte l'item courant
		const req = new InfoReqCurrentItem();
		this.genView.reg.env.infoBroker.dispatchInfo(req, this);
		if (req.srcUri) this.itemPtr.setSrcRef(req.srcUri, req.shortDesc);
		else this.itemPtr.setSrcRef(null);
	}

	closeTab() {
		if (!this.pinned) return;
		if (this.genView.currentTab === this) this.genView.setCurrentTab((DOM.findNextSibling(this.tab, isGeneratorTabPointer) || DOM.findPreviousSibling(this.tab, isGeneratorTabPointer))?.genTab);
		if (this.genView.reg.env.place instanceof WspsLivePlace)
			this.genView.reg.env.place.eventsMgr.removeListener('wspUriChange', this._lstn);
		this.tab.remove();
		this.genView.saveTabs();
	}

	protected _newCloseButton(tabIndex: string): Button {
		return <Button onclick={this.onClose} tabindex-custom={tabIndex} icon="/@skin@/commons/icons/close.svg" ui-context="bar" title="Ferme la vue des publications de cet item"/> as Button;
	}

	protected onClose(this: Button) {
		(this.parentElement as IGeneratorTabPointer).genTab.closeTab();
	}

	protected onPin(this: Button, ev: MouseEvent) {
		const spanTab = this.parentElement as IGeneratorTabPointer;
		const genTab = spanTab.genTab;
		genTab.genView.liveTab = new GeneratorTab(genTab.genView, true);
		genTab.setPinState(true);
		//Remplace le bouton Pin par le bouton Close
		this.parentNode.insertBefore(genTab._newCloseButton(this.tabIndexCustom.toString()), this);
		this.remove();
		//on se replace après le bouton addTab
		spanTab.parentNode.insertBefore(spanTab, DOM.findNextSibling(spanTab, isGeneratorTabPointer));
		genTab.genView.setCurrentTab(genTab);
		genTab.genView.saveTabs();
		//if (genTab.itemPtr.srcRef == null) SrcPointerFastSelect.SINGLETON.execute(genTab.itemPtr, ev);
	}

	protected setPinState(pinned: boolean) {
		if (pinned) {
			this.pinned = true;
			this.itemPtr.readOnly = false;
			this.itemPtr.title = "";
		} else {
			this.pinned = false;
			this.itemPtr.readOnly = true;
			this.itemPtr.title = "Publications de l'item actif";
		}
	}
}

interface IGeneratorTabPointer extends HTMLElement {
	genTab: GeneratorTab
}

function isGeneratorTabPointer(n: any): n is IGeneratorTabPointer {return n?.genTab instanceof GeneratorTab}

interface JLDGeneratorTabs {
	currTab: JLDGeneratorTab
}

/** */
interface JLDGeneratorTab {
	srcRef: srcRef
	codeGen?: string
}

/**
 * Enregistrements des tabs en privateDatas.
 */
interface JGenTabsSaved {
	tabs: JLDGeneratorTab[]
}


export interface Generators extends BaseAreaView<IRegPointer<IWspUiEnv>> {
	initialize(init?: OGeneratorsInit): this
}

export interface OGeneratorsInit extends OBaseAreaViewInit<IRegPointer<IWspUiEnv>> {

	/** Retourne true si le pubNode est conservé */
	pubNodeMatchFilter?: (pubNode: IItemPubNode) => boolean

	/** Uri de destination libre. Usage : styler */
	customDestPath?: wspUri
}

/** Mémoire des dernières url CID. */
let cidManifestUrls: string[];


export class Generators extends BaseAreaView<IRegPointer<IWspUiEnv>> implements ICidUiHandler {
	reg: IReg<IWspUiEnv>;
	wsp: Wsp;

	onCodePubChange = new EventMgr<(gen: Generators) => void>();

	codePub: string;

	pubTree: GridSmall;
	pubActions: BarActions<IPubCtx>;

	genRoot: HTMLElement;
	genRefreshBtn: Button;
	genIllus: HTMLImageElement;
	genInfos: HTMLElement;
	genSkins: HTMLFormElement;
	genProps: HTMLFormElement;

	cidRoot: HTMLElement;
	cidManifestHead: HTMLElement;
	cidDetails: HTMLElement; //select manifest, select process, userWait

	datas: GridDataHolderJsonTree<IItemPubNode> = new GridDataHolderJsonTree<IItemPubNode>('ch').setDefaultOpenState(defaultOpenStates);

	protected pubNodeMatchFilter?: (pubNode: IItemPubNode) => boolean;

	/** Uri de destination libre. Usage : styler */
	customDestPath?: wspUri;

	get shortDesc(): JSrcFields {return this.pubActions.actionContext.shortDesc}

	protected _initialize(init: OGeneratorsInit) {
		super._initialize(init); //init this.reg, this.area, this.areaContext
		this.wsp = this.reg.env.wsp;
		const sr = this.attachShadow(DOMSH.SHADOWDOM_INIT);
		this.reg.installSkin("scroll/small", sr);
		this.reg.installSkin("form-control-areas", sr);
		this._initAndInstallSkin(this.localName, init);
		const layoutV = (init.area as IWbToolLocatedArea)?.layout === 'v';
		this.reg.installSkin(layoutV ? "wsp-generators/v" : "wsp-generators/h", sr);

		this.pubNodeMatchFilter = init.pubNodeMatchFilter;
		this.customDestPath = init.customDestPath;

		this.pubTree = sr.appendChild(<GridSmall id="tree" î={{
			reg: this.reg,
			columnDefs: [new GridColTreeDef('genTree')
				.setFlex('1rem', 1, 1).setMinWidth('55px').setChildrenIndent(1.5)
				.setCellBuilder(new CellBuilderGen())],
			hideHeaders: true,
			autoSelOnFocus: 'first',
			skinScroll: 'scroll/small',
			emptyBody: <div style="font-style:italic;">Aucune fonction de publication disponible</div>
		} as OGridSmallInit} c-resizable=""/>) as GridSmall;
		this.pubTree.dataHolder = this.datas;
		this.pubTree.addEventListener("grid-select", this.onGridSelect);
		sr.appendChild(<c-resizer c-orient={layoutV ? 'column' : 'row'}/>);
		const body = sr.appendChild(<section id="body" c-resizable=""/>);

		//GEN
		this.genRoot = body.appendChild(<div id="genRoot" hidden="true"/>);
		const genTop = this.genRoot.appendChild(<div id="genTop"/>);
		const genTopMain = genTop.appendChild(<div id="genTopMain"/>);
		this.genRefreshBtn = genTop.appendChild(<Button id="refresh" î={{
			icon: "/@skin@/commons/icons/refresh.svg",
			uiContext: 'bar',
		} as OButtonInit} onclick={this.refreshGenRootUi} title="Rafraichir"/>) as Button;
		this.genIllus = genTopMain.appendChild(<div id="illusCtn"><img id="illus"/></div>).firstChild as HTMLImageElement;
		const topInfos = genTopMain.appendChild(<div id="topInfos"/>);
		this.genInfos = topInfos.appendChild(<div id="infos"/>);
		this.genSkins = topInfos.appendChild(<form id="skins"/>) as HTMLFormElement;
		this.genSkins.addEventListener("change", this.onSkinChange);
		this.genProps = this.genRoot.appendChild(<form id="props"/>) as HTMLFormElement;

		//CID
		this.cidRoot = body.appendChild(<div id="cidRoot" hidden="true"/>);
		this.cidManifestHead = this.cidRoot.appendChild(<div id="cidManifest"/>);
		this.cidDetails = this.cidRoot.appendChild(<div id="cidDetails"/>);

		this.pubActions = body.appendChild(<c-bar-actions î={{
			reg: this.reg,
			actionContext: {
				reg: null, // this.reg non dynamique, propre à chaque itemType
				uiContext: this,
				wsp: this.wsp,
				shortDesc: null,
				pubNode: null,
				genInfo: null,
				async genProps(): Promise<Jsonisable> {
					if ((this.uiContext as Generators).genRoot.hidden) return null;
					const skins = (this.uiContext as Generators).genSkins;
					const rootProps = (this.uiContext as Generators).genProps;
					if (skins.hidden && rootProps.hidden) return null;
					if (!rootProps.reportValidity()) return false;
					const props = {};
					if (!skins.hidden) FORMS.formToJson(skins, props);
					if (!rootProps.hidden) FORMS.formToJson(rootProps, props);
					return props;
				},
				customDestPath: this.customDestPath,
			} as IPubCtx,
			uiContext: "dialog",
			disableFullOverlay: true
		} as OBarActionsInit<IPubCtx>} id="actions" hidden="true"/>) as BarActions<IPubCtx>;

	}

	setSrc(shortDesc: JSrcFields, codeGenToSelect?: string) {
		const ctx = this.pubActions.actionContext;
		if (ctx.shortDesc === shortDesc && this.codePub === codeGenToSelect) return; //évite refreshs successifs à l'init (set currentTab, set ptrItem, msg init mainView).
		ctx.shortDesc = shortDesc;
		if (!shortDesc || shortDesc.srcSt < 0) {
			this.datas.setDatas([]);
		} else {
			const itemType = this.wsp.wspMetaUi.getItemType(shortDesc.itModel);
			const itemReg = ctx.reg = REG.createSubReg(this.reg, itemType);
			itemReg.env.securityCtx = SEC.createSub(this.reg.env.securityCtx, shortDesc.srcRoles, shortDesc.srcRi);
			const tree = itemType.buildPubTree(itemReg.env.securityCtx, this.pubNodeMatchFilter);
			this.datas.setDatas(tree);
			if (codeGenToSelect) {
				const newGen = itemType.getPub(codeGenToSelect, tree);
				if (newGen) {
					this.datas.openFolder(newGen); //Fore l'ouverture de la hiérerachie
					const offset = this.datas.getOffset(newGen);
					if (offset >= 0) this.pubTree.setSelectedRows(offset);
				}
			} else {
				const pub = tree[0];
				if (pub && (pub.genNodeType === "gen" || pub.genNodeType === "cid")) {
					//Si 1ère ligne n'est pas un dossier mais un gen, on le sélectionne par défaut
					this.pubTree.setSelectedRows(0);
				}
			}
		}
	}

	protected onGridSelect(this: GridSmall, ev: CustomEvent) {
		const generators = DOMSH.findHost<Generators>(this);
		const newPubNode = generators.datas.getDataByOffset(this.getSelectedRow());
		if (newPubNode) {
			generators.codePub = newPubNode.codeGenStack;
			generators.onCodePubChange.emit(generators);
		}
		if (newPubNode !== generators.pubActions.actionContext.pubNode) generators.setPubNode(newPubNode);
	}

	protected onSkinChange(this: HTMLFormElement, ev: CustomEvent) {
		//console.log("onSkinChange::::", ev);
		const generators = DOMSH.findHost<Generators>(this);
		generators.setGenIllus((ev.target as HTMLInputElement).value);
	}

	protected async setPubNode(pubNode: IItemPubNode | null) {
		if (pubNode) {
			if (pubNode.genNodeType === 'cid') {
				DOM.setHidden(this.cidRoot, false);
				DOM.setHidden(this.genRoot, true);
				return this.initViewCid(pubNode);
			} else if (pubNode.genNodeType !== 'dir') {
				DOM.setHidden(this.genRoot, false);
				DOM.setHidden(this.cidRoot, true);
				return this.initViewGen(pubNode);
			}
		}
		//Rien à afficher...
		this.initViewEmpty();
	}

	protected initViewEmpty() {
		this.pubActions.actionContext.pubNode = null;
		this.pubActions.actionContext.genInfo = null;
		this.pubActions.actionContext.cidInfo = null;
		DOM.setHidden(this.genRoot, true);
		DOM.setHidden(this.cidRoot, true);
		DOM.setHidden(this.pubActions, true);
	}

	protected refreshGenRootUi(this: Button) {
		const generators = DOMSH.findHost<Generators>(this);
		generators.initViewGen(generators.pubActions.actionContext.pubNode);
	}

	protected async initViewGen(genNode: IItemPubNode) {
		try {
			const ctx = this.pubActions.actionContext;
			const idx = genNode.codeGenStack.lastIndexOf('_');
			const cdGen = idx < 0 ? genNode.codeGenStack : genNode.codeGenStack.substring(idx + 1);
			ctx.pubNode = genNode;
			const genInfoSvc: (wsp: Wsp, uiContext: HTMLElement, srcRef: srcRef, codeGenStack: string, addExtraInfos?: boolean, customFullUriDest?: string) => Promise<JGenInfo> = ctx.reg.getSvc("gen.action.genInfo") || ITEM.fetchGenInfo;
			const genInfo: JGenInfo = await genInfoSvc.call(this, this.wsp, this, SRC.srcRef(ctx.shortDesc), genNode.codeGenStack, genNode.needExtraProps, this.customDestPath);
			if (ctx.pubNode !== genNode || !genInfo) return; //race cond
			ctx.genInfo = genInfo;
			ctx.cidInfo = null;
			const infosTpl = await (genNode.infos || this.infosTpl)(ctx);
			if (ctx.pubNode !== genNode) return; //race cond

			DOM.setHidden(this.genRoot, false);
			DOM.setHidden(this.genRefreshBtn, !genNode.showRefreshBtn || genInfo.status === "working");
			if (genInfo.skins && genInfo.skins.length > 1) {
				// Tri des skins par ordre alphabétique
				genInfo.skins.sort((skinA, skinB) => skinA.title.localeCompare(skinB.title, "en", {sensitivity: "base"}));
				DOM.setHidden(this.genSkins, false);
				//Skins
				render(this.skinsTpl(ctx), this.genSkins);
				this.genSkins["skin"].value = genInfo.skin || 'default'; //affectation du skin courant
			} else {
				DOM.setHidden(this.genSkins, true);
			}
			//Illus
			this.setGenIllus(genInfo.skin);
			//Infos
			render(infosTpl, this.genInfos);
			//Props
			const propsLists: string[] = [];
			propsLists.push(`params:gen:${cdGen}`);
			if (genNode.codeGenStack != cdGen) propsLists.push(`params:gen:${genNode.codeGenStack}`);
			propsLists.push(`params:genNature:${genNode.genNature}`);
			propsLists.push("params:gen");
			const propsListsAreas = ctx.reg.mergeLists<IArea<IPubCtx & IControlAreaContext> | Promise<IArea<IPubCtx & IControlAreaContext>>>(...propsLists);
			if (genNode.props || propsListsAreas) {
				DOM.setHidden(this.genProps, false);

				let tpl = genNode.props ? await genNode.props(ctx) : xhtml`<fieldset>
					<div class="fields" area-ids="*"/>
				</fieldset>`;
				if (ctx.pubNode !== genNode) return; //race cond

				// Réinitialisation nécessaire des components dont la structure HTML est constante,
				// tout en exploitant le contexte à l'initialisation (reg, ...) : lit ne sait pas gérer ces cas
				// exemple : évolution du contexte de 'DynGenParam' faux sans ça lorsqu'on change d'item
				if (this.genProps.hasChildNodes()) render(null, this.genProps);
				render(tpl, this.genProps, {});

				if (propsListsAreas) {
					let areaCtx: IPubCtx & IControlAreaContext = Object.create(ctx);
					areaCtx.buildControlLabel = true;
					const areas = await Promise.all(propsListsAreas);
					if (ctx.pubNode !== genNode) return; //race cond
					if (await AREAS.applyLayout(this.genProps, areas, areaCtx, true, () => ctx.pubNode !== genNode) === null) {
						//race cond
						return;
					}
				}

				FORMS.jsonToForm(ctx.genInfo.storedProps || {}, this.genProps, false, false);//forceClear=false pour préserver les valeurs par défaut
				DOM.setAttrBool(this.genProps, "disabled", genInfo.status === "working");
			} else {
				DOM.setHidden(this.genProps, true);
			}
			//Actions
			if (genInfo.status === 'working') {
				DOM.setHidden(this.pubActions, true);
				setTimeout(() => {
					if (ctx.pubNode === genNode && ctx.genInfo.status === 'working') this.initViewGen(genNode);
				}, 10000); //sécurise un refresh toutes les 10s en plus de websocket
			} else {
				DOM.setHidden(this.pubActions, false);
				const actionsLists: string[] = [];
				actionsLists.push(`actions:gen:${cdGen}`);
				if (genNode.codeGenStack != cdGen) actionsLists.push(`actions:gen:${genNode.codeGenStack}`);
				actionsLists.push(`actions:genNature:${genNode.genNature}`);
				actionsLists.push("actions:gen");
				if (genNode.actionListsCode) actionsLists.push(...genNode.actionListsCode);
				const actions = await Promise.all(ctx.reg.mergeLists(...actionsLists)) as IAction<IPubCtx>[];
				if (ctx.pubNode !== genNode) return; //race cond
				this.pubActions.actions = actions
			}
		} catch (e) {
			console.error(e);
			this.initViewEmpty();
		}
	}

	protected async initViewCid(cidNode: IItemPubNode) {
		try {
			const ctx = this.pubActions.actionContext;
			ctx.pubNode = cidNode;
			const allHosts = await CID.getCidHostsForOutput(this.reg);
			ctx.genInfo = null;
			ctx.cidInfo = {
				cidHosts: cidNode.cidHostIs === null ? [] : (cidNode.cidHostIs ? Array.from(CID.filterIsOr(allHosts, cidNode.cidHostIs)) : allHosts)
			};
			//TODO fetch le lastCidEndPoint pour ce src et ce cidNode.codeGenStack
			// pour afficher ces infos, dans la meme logique que
			// 		render(await (genNode.infos || this.infosTpl)(ctx), this.genInfos);

			if (ctx.pubNode !== cidNode) return; //race cond
			DOM.setHidden(this.cidRoot, false);
			//Fixation des données connues
			if (ctx.cidInfo.cidHosts.length !== 1) {
				//Interface de sélection du serveur
				this.cidSeletHost();
			} else {
				// 1 seul serveur connu
				ctx.cidInfo.lastManifest = await ctx.cidInfo.cidHosts[0].fetchManifest();
				if (ctx.pubNode !== cidNode) return; //race cond
				this.cidOnManifestKnown();
			}
		} catch (e) {
			console.error(e);
			this.initViewEmpty();
		}
	}

	/** Affiche l'interface de sélection d'un server Cid. */
	protected cidSeletHost() {
		const ctx = this.pubActions.actionContext;
		DOM.setHidden(this.pubActions, true);
		this.pubActions.actions = null;
		this.cidDetails.textContent = null;
		if (ctx.cidInfo.cidHosts.length > 0) {
			this.cidManifestHead.textContent = "Sélection du serveur cible";
			const group = this.cidDetails.appendChild(<ul/>);
			for (let i = 0, s = ctx.cidInfo.cidHosts.length; i < s; i++) {
				const host = ctx.cidInfo.cidHosts[i];
				group.appendChild(<li><a onclick={this.onCidSelectHost} href={i}>{host.label}</a></li>);
			}
			if (ctx.pubNode.cidManifestUrlInput) this.buildInputManifest(group.appendChild(<li/>), "Autre");
		} else {
			this.cidManifestHead.textContent = "Définition du serveur cible";
			this.buildInputManifest(this.cidDetails.appendChild(<div id="manifestAlone"/>), "URL du serveur");
		}
	}

	buildInputManifest(parent: HTMLElement, label: string) {
		parent.appendChild(<div class="manifestLabel">{label}</div>);
		if (cidManifestUrls === undefined) {
			cidManifestUrls = LASTDATAS.getLastDatas(document.body, "cidManifestUrls") || [];
			LASTDATAS.buildLastDatasHooks.add((ld) => {
				if (cidManifestUrls.length > 10) cidManifestUrls.splice(10, cidManifestUrls.length - 10);
				ld["cidManifestUrls"] = cidManifestUrls;
			});
		}
		if (cidManifestUrls.length > 0) parent.appendChild(<datalist id="histValues">{cidManifestUrls.map((url) => <option value={url}/>)}</datalist>)
		const inputManifest = <input id="manifestInput" type="url" list="histValues" oninput={this.onManifestInput} onchange={function (this: HTMLInputElement) {DOMSH.findHost<Generators>(this).onManifestChange(this)}}/> as HTMLInputElement
		parent.appendChild(<div id="manifestEdit">
			{inputManifest}
			<c-button id="manifestValid" î={{reg: this.reg, label: "Valider", disabled: true}} onclick={function (this: HTMLInputElement & ICidManifestPointer) {DOMSH.findHost<Generators>(this).cidUseManifest(this.cidManifest)}}/>
		</div>);
		parent.appendChild(<c-msg id="manifestInputResult" î={{noShadow: true}}/>);
		if (cidManifestUrls.length === 1) {
			inputManifest.value = cidManifestUrls[0];
			this.onManifestChange(inputManifest);
		}
	}

	async onManifestChange(input: HTMLInputElement) {
		const msg = this.shadowRoot.getElementById("manifestInputResult") as MsgLabel;
		const btn = this.shadowRoot.getElementById("manifestValid") as Button & ICidManifestPointer;
		btn.cidManifest = null;
		if (!input.validity.valid) {
			msg.setCustomMsg("Saisissez une URL valide permettant d'obtenir les caractéristiques du serveur (manifeste CID)", "info");
			btn.cidManifest = null;
			btn.disabled = true;
		} else {
			const ctx = this.pubActions.actionContext;
			const pubNode = ctx.pubNode;
			try {
				btn.cidManifest = input.value ? await CID.getCidManifest(input.value) : null;
				if (pubNode !== ctx.pubNode) return; //race cond
			} catch (e) {
				//console.log(e);
			}
			if (btn.cidManifest) {
				msg.setCustomMsg("Serveur reconnu : " + CID.getCidManifestLabel(this.pubActions.actionContext.cidInfo.cidHosts, btn.cidManifest), "info");
				btn.disabled = false;
				let newUrl = input.value;
				for (let i = 0; i < cidManifestUrls.length; i++) {
					const u = cidManifestUrls[i]
					if (u.startsWith(newUrl)) {
						cidManifestUrls.splice(i--, 1);
					} else if (newUrl.startsWith(u)) {
						newUrl = u;
					}
				}
				cidManifestUrls.splice(0, 0, newUrl);
			} else {
				msg.setCustomMsg("Aucun serveur reconnu à cette URL (manifeste CID non trouvé), ou politique de sécurité du serveur incompatible", "error");
				btn.disabled = true;
			}
		}
	}

	onManifestInput(this: HTMLInputElement, ev: Event) {
		const me = DOMSH.findHost<Generators>(this);
		if (me._cidMnInputWaiter) clearTimeout(me._cidMnInputWaiter);
		me._cidMnInputWaiter = setTimeout(() => me.onManifestChange(this), 800) as any;
	}

	protected _cidMnInputWaiter: number;

	cidUseManifest(manifest: CidManifest) {
		if (!manifest) return;
		const ctx = this.pubActions.actionContext;
		ctx.cidInfo.lastManifest = manifest;
		this.cidOnManifestKnown();
	}

	/** */
	protected async onCidSelectHost(this: HTMLAnchorElement, ev: MouseEvent) {
		ev.preventDefault();
		const me = DOMSH.findHost<Generators>(this);
		const ctx = me.pubActions.actionContext;
		const cidNode = ctx.pubNode;
		ctx.cidInfo.lastManifest = await ctx.cidInfo.cidHosts[parseInt(this.getAttribute('href'))].fetchManifest();
		if (ctx.pubNode !== cidNode) return; //race cond
		me.cidOnManifestKnown();
	}

	/** ctx.cidInfo.lastManifest renseigné */
	protected async cidOnManifestKnown() {
		const ctx = this.pubActions.actionContext;
		const cidNode: IDatasItemCidNode = ctx.pubNode;
		const manifest = ctx.cidInfo.lastManifest;
		if (!manifest) return this.cidSeletHost();
		this.cidManifestHead.textContent = "Serveur : " + CID.getCidManifestLabel(this.pubActions.actionContext.cidInfo.cidHosts, manifest);
		if (ctx.pubNode.cidManifestUrlInput || ctx.cidInfo.cidHosts.length !== 1) {
			//Possibilité de changer
			this.cidManifestHead.appendChild(<c-button class="changeBtn" icon="/@skin@/wsp/views/generators/change.svg" title="Changer de serveur"
																								 onclick={function (this: Button, ev: MouseEvent) {return DOMSH.findHost<Generators>(this).cidSeletHost()}}/>);
		}
		if (cidNode.cidProcessSelector) {
			ctx.cidInfo.cidProcesses = await cidNode.cidProcessSelector(ctx);
			if (cidNode !== ctx.pubNode) return; //race cond
		} else if (cidNode.cidProcessIs) {
			ctx.cidInfo.cidProcesses = manifest.getProcesses(...cidNode.cidProcessIs);
		}
		DOM.setHidden(this.pubActions, false);
		this.pubActions.actions = await Promise.all(ctx.reg.mergeLists(...(cidNode.actionListsCode || []), `actions:cid:${ctx.pubNode.codeGenStack}`, ctx.pubNode.codeGenStack.indexOf('_') > 0 ? "actions:cidGen" : "actions:cidScar")) as IAction<IPubCtx>[];
		this.cidRefreshOnSessionChange();
	}

	cidRefreshOnSessionChange() {
		const ctx = this.pubActions.actionContext;
		if (!ctx.cidInfo) return;
		this.pubActions.refreshContent();
		if (ctx.cidInfo.cidSession) {
			//console.log("cidRefreshOnSessionChange::::", ctx.cidInfo.cidSession);
			switch (ctx.cidInfo.cidSession.state) {
			case ECidSessionState.authenticating:
				this.cidDetails.textContent = null;
				this.cidDetails.appendChild(<div class="cidUploading"><span>Authentification en cours...</span></div>);
				return;
			case ECidSessionState.inStep:
			case ECidSessionState.uiProcessSel: //en principe impossible
			case ECidSessionState.notStarted: //en principe impossible
				this.cidDetails.textContent = null;
				this.cidDetails.appendChild(<div class="cidUploading"><span>Déploiement en cours...</span></div>);
				return;
			case ECidSessionState.uiAuth:
				// uiWait en cours
				return;
			case ECidSessionState.failed:
			case ECidSessionState.ended:
			case ECidSessionState.aborted:
				//on réaffiche l'état de la dernière diffusion réussie.
			}
		}
		this.cidDetails.textContent = null;
		//TODO info de la mémoire dernière diffusion
	}


	protected setGenIllus(skinCode: string) {
		const genInfo = this.pubActions.actionContext.genInfo;
		const genNode = this.pubActions.actionContext.pubNode;
		const skin = skinCode && genInfo && genInfo.skins ? genInfo.skins.find((s) => s.code === skinCode) : null;
		const src = skin && skin.hasIllus ? ITEM.getGenSkinIllusUrl(this.wsp, genNode, skin) : genNode.illusUrl;
		if (src !== this.prevIllusSrc) this.genIllus.src = this.prevIllusSrc = src;
	}

	protected prevIllusSrc: string;

	onViewHidden(closed?: boolean): void {
		if (closed) {
			this.reg.env.place.eventsMgr.removeListener("onConnectionRenewed", this._onConnectionRenewed);
			this.reg.env.universe.wsFrames.ws.msgListeners.removeListener("wspGen", this._onMsgWspGen);
			this._onMsgWspGen = null;
			this._onConnectionRenewed = null;
		}
	}

	onViewShown() {
		if (!this._onMsgWspGen) {
			//console.log("Generators: Init Ws listening..............");
			this._onMsgWspGen = (m: JWspGenMsg) => {
				const ctx = this.pubActions.actionContext;
				if (!ctx.pubNode || ctx.shortDesc.srcUri !== m.srcUri || m.wsp !== ctx.wsp.code || m.customDestPath !== this.customDestPath) return;
				this.setPubNode(ctx.pubNode);
			};
			this._onConnectionRenewed = () => {
				const ctx = this.pubActions.actionContext;
				if (ctx.pubNode) this.setPubNode(ctx.pubNode);
			}
			this.reg.env.place.eventsMgr.on("onConnectionRenewed", this._onConnectionRenewed);
			this.reg.env.universe.wsFrames.ws.msgListeners.on("wspGen", this._onMsgWspGen);
		}
	}

	protected _onConnectionRenewed: (states: JWspWorkingInitStates) => void;

	protected _onMsgWspGen: (m: JWspGenMsg) => void;

	infosTpl(ctx: IPubCtx): TemplateResult {
		let dt: string;
		const deploy = ctx.pubNode.genNature === 'deploy';
		if (ctx.genInfo.status === 'working') {
			dt = deploy ? "Transfert en cours..." : "Génération en cours...";
		} else if (ctx.genInfo.lastGen) {
			const lastGenDate = DTFormatter.format(ctx.genInfo.lastGen);
			if (ctx.genInfo.status === 'failed') dt = deploy ? `Transfert en erreur le ${lastGenDate}` : `Généré en erreur le ${lastGenDate}`;
			else if (ctx.genInfo.status === 'warning') dt = deploy ? `Transféré avec anomalies le ${lastGenDate}` : `Généré avec anomalies le ${lastGenDate}`;
			else dt = deploy ? `Transféré le ${lastGenDate}` : `Généré le ${lastGenDate}`;
		} else if (ctx.genInfo.status === "failed") {
			dt = deploy ? "Dernier transfert en erreur" : "Dernière génération en erreur";
		} else {
			dt = deploy ? "Non transféré" : "Non généré";
		}
		return xhtml`<div class="genTi ${ctx.genInfo.status}">${ctx.pubNode.genTitle || ctx.genInfo.title}<span class="itemTi"> - ${ITEM.getTitle(ctx.shortDesc) || ITEM.getItemUriLabel(ctx.shortDesc.srcUri, ctx.shortDesc)}</span></div>
<div class="reason ${ctx.genInfo.reason ? '' : 'hidden'}">Un fichier de la génération est verrouillé. FERMEZ les applications tierces et recommencez.</div>
<div class="dt ${ctx.genInfo.status}">${dt}</div>`;
	}

	skinsTpl(ctx: IPubCtx): TemplateResult {
		return xhtml`${ctx.genInfo.skins.map((skin: JGenSkin) => {
			return xhtml`<span class="skin"><input type="radio" name="skin" value="${skin.code}" id="sk_${skin.code}"/><label for="sk_${skin.code}">${skin.title}</label></span>`
		})}`
	}

	//*** ICidUiHandler ***

	async webAuth(session: CidSession, step: CidWebAuthStep): Promise<ICidStepResult> {
		const frame = <iframe style="flex:1; border: none;"/> as HTMLIFrameElement;
		if (UiThemeDeskFeat.isIn(desk)) (frame as any).injectTheme = UiThemeDeskFeat.injectTheme;
		const dialog = POPUP.showDialog<'ok' | null>(frame, this, {titleBar: "Authentification", initHeight: "min(60vh,40em)", initWidth: "60vw"});
		dialog.onNextClose().then((r) => {if (!r) session.onCidFrameMessage({cidAuth: "failed"})});
		const res = await step.initFrame(frame, session);
		dialog.close('ok');
		return res;
	}

	async uiWait(session: CidSession, step: CidStep): Promise<ICidStepResult | null> {
		this.cidDetails.textContent = null;
		const iframe = this.cidDetails.appendChild(<iframe class="cidWaiting"/>) as HTMLIFrameElement;
		if (UiThemeDeskFeat.isIn(desk)) (iframe as any).injectTheme = UiThemeDeskFeat.injectTheme;
		return step.initFrame(iframe, session);
	}

	async interact(session: CidSession, step: CidStep): Promise<ICidStepResult> {
		/** Ignorer les steps d'interaction optionnelles **/
		const ctx = this.pubActions.actionContext;
		if (session.config.cidPassOptionalInteraction && step.def.getAttribute("required") === "false") return {};
		const frame = <iframe style="flex:1; border: none;"/> as HTMLIFrameElement;
		if (UiThemeDeskFeat.isIn(desk)) (frame as any).injectTheme = UiThemeDeskFeat.injectTheme;
		const dialog = POPUP.showDialog<'ok' | null>(frame, this, {initHeight: "min(90vh,50em)", initWidth: "min(90vw,80em)", titleBar: {barLabel: {label: session.cidProcess.label.getStr("fr")}}, resizer: {}});
		dialog.onNextClose().then((r) => {if (!r) session.onCidFrameMessage({cidInteraction: "aborted"})});
		const res = await step.initFrame(frame, session);
		dialog.close('ok');
		return res;
	}

	async selectProcess(session: CidSession, choices: Set<CidProcess>): Promise<CidProcess | null> {
		//console.trace("TODO select Process UI");
		return choices.values().next().value;
	}
}

REG.reg.registerSkin("wsp-generators", 1, /* language=CSS */ `
	:host {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
	}

	:focus-visible {
		outline: var(--focus-outline);
	}

	[hidden] {
		display: none !important;
	}

	input,
	select,
	textarea {
		background-color: var(--form-bgcolor);
		color: var(--form-color);
		border: 1px solid var(--border-color);
		font-size: inherit;
	}

	input:invalid,
	select:invalid,
	textarea:invalid {
		border: 1px solid var(--error-color);
	}

	#tree {
		flex: 1 1 30%;
		border: none;
		background-color: var(--row-bgcolor);
	}

	#body {
		flex: 3 1 70%;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
	}

	#genRoot {
		flex: 1;
		overflow: auto;
	}

	#genTop {
		display: flex;
		min-height: 0;
		min-width: 0;
		align-items: start;
	}

	#genTopMain {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		justify-content: center;
	}

	#topInfos {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
		text-align: center;
		justify-content: center;
	}

	#illusCtn {
		display: flex;
		justify-content: center;
		align-items: center;
		user-select: none;
	}

	#illus {
		margin: .5em;
		min-width: calc(var(--icon-size) * 2);
		min-height: calc(var(--icon-size) * 2);
	}

	#cidRoot,
	#cidDetails {
		flex: 1;
		display: flex;
		min-height: 0;
		min-width: 0;
		flex-direction: column;
	}

	#cidRoot {
		overflow: auto;
	}

	#cidManifest {
		margin: .2em;
		font-weight: bold;
		font-size: 1.2em;
		text-align: center;
		user-select: none;
	}

	#actions {
		border-top: 1px solid var(--border-color);
	}

	.manifestLabel {
		user-select: none;
	}

	#manifestInput {
		flex: 1;
	}

	#manifestAlone {
		margin: 2em;
	}

	#manifestEdit {
		display: flex;
	}

	#manifestInput:focus {
		outline: var(--focus-outline);
	}

	#manifestInputResult {
		font-style: italic;
		color: var(--fade-color);
	}

	.genTi {
		margin: .2em;
		font-weight: bold;
		font-size: 1.2em;
		user-select: none;
	}

	.ok {
		color: var(--valid-color);
	}

	.warning {
		color: var(--warning-color);
	}

	.failed {
		color: var(--error-color);
	}

	.null {
		color: var(--fade-color);
	}

	.working {
		color: var(--fade-color);
	}
	
	.itemTi {
	  font-size: .8em;
	  font-weight: normal;
  }

	.dt {
		font-style: italic;
	}

	.dt.working {
		background: left no-repeat url(/@skin@/wsp/views/generators/generating.webp);
		padding-left: 30px;
		min-height: 30px;
		display: flex;
		align-items: center;
	}

	.reason {
		font-weight: bold;
		color: var(--error-color);
		margin: .1em;
		padding: .1em;
	}

	.reason.hidden {
		display: none;
	}

	.skin {
		display: inline-block;
		margin: .2em;
		user-select: none;
	}

	#props {
		margin-block-start: .5em;
	}

	#props[disabled] {
		display: none;
	}

	fieldset {
		border: none;
		padding: 0;
		margin: 0;
		min-width: 0;
	}

	/* control en dehors d'un ctrlLbl => s'étend sur les deux colonnes */
	.fields > .ctrl {
		grid-column-start: span 2;
	}

	/** Contrôle sans */
	.ctrlFull {
		grid-column-start: span 2;
	}

	input, textarea, select,
	.formElt {
		margin-inline-end: .5em;
	}

	.lbl, input, textarea, select,
	.formElt, .ctrl {
		margin-block-start: .5em;
	}

	/** Pour compat asc pack. A supprimer en 5.1 */
	.fieldLabel {
		color: var(--alt1-color);
		display: inline-block;
		user-select: none;
		margin-inline-end: .5rem;
		margin-inline-start: .3rem;
	}

	/** Pour compat asc pack. A supprimer en 5.1 */
	.fieldValue {
		margin-inline-start: 0.5em;
		grid-column: 2;
	}

	/** Pour compat asc pack. A supprimer en 5.1 */
	input.fieldValue {
		width: fit-content;
	}


	.changeBtn {
		display: inline-flex;
	}

	.cidWaiting {
		flex: 1;
		border: none;
		border-top: 1px solid var(--border-color);
	}

	.cidUploading {
		flex: 1;
		display: flex;
		align-items: center;
		font-style: italic;
		margin: 0 2em;
	}
`);

REG.reg.registerSkin("wsp-generators/h", 1, /* language=CSS */ `
	c-resizer {
		width: 1px;
	}

	#props > div,
	.fields /* deprecated ? */
	{
		flex: 1;
		display: grid;
		min-width: 10em;
		grid-template-columns: auto 1fr;
		grid-row-gap: .5rem;
		grid-auto-rows: max-content;
	}

	.fields > .ctrlLbl,
	.field {
		display: contents;
	}

	.lbl {
		margin-inline-start: .5em;
	}
`);

REG.reg.registerSkin("wsp-generators/v", 1, /* language=CSS */ `
	:host {
		flex-direction: column;
	}

	c-resizer {
		height: 1px;
	}

	.ctrlLbl {
		display: block;
		margin-inline-start: .5em;
	}
`);

customElements.define("wsp-generators", Generators);

const DTFormatter = new Intl.DateTimeFormat("fr", {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'});


function defaultOpenStates(d: IItemPubNode): boolean {
	//On clos les gens avec des subGens, mais laisse ouvert les dossiers de gen.
	return d.genNodeType === 'dir';
}

/** */
class CellBuilderGen extends CellBuilderIconLabel {

	constructor() {
		super("label");
		this.iconKey = "iconUrl";
		this.iconFilter = "var(--filter)";
	}

	redrawCell(row: GridDataRowJsonTree<IItemPubNode>, root: HTMLElement): void {
		super.redrawCell(row, root);
		const span = root.firstElementChild as HTMLElement;
		if (row.rowDatas.genNodeType === 'dir') {
			span.style.display = row.rowDatas.iconUrl ? '' : 'none';
			root.style.fontWeight = 'bold';
		} else {
			span.style.display = '';
			root.style.fontWeight = 'normal';
		}
	}
}

/** */

/** API à implémenter par les pages fournies par le dynGenParam */
interface IWindowDynGenParam {
	_genPropsMgr: IWindowDynGenParamMgr
}

interface IWindowDynGenParamMgr {
	/**
	 * Initialise ou rafraichit le contexte du genBox
	 *	ATTENTION : cette méthode peut être ré-appelée aprés première exploitation des props (ex : aprés une génération). Elle ne doit
	 * donc pas nécessairement reseter la page web (contexte dépendant)
	 * @param propsObj : propriétés ENREGISTREES uniquement
	 */
	refresh(propsObj: Jsonisable, isReadOnly: boolean, forceRefresh: boolean): void,

	/** compute l'objet des propriétés du générateur */
	get(): Jsonisable,

	/** contrôle la validité du composant */
	checkValidity(): boolean,
}


export interface ODynGenParamInit extends ODynGenInit, OFormElementInit {
	reg?: IReg<IWspUiEnv>
	/**  */
	dynGenInit: ODynGenInit
}

export class DynGenParam extends MxFormElement(BaseElement) implements IViewContainer, IFormJsonisable {

	protected config: ODynGenParamInit;

	reg: IReg<IWspUiEnv>;

	view: DynGen;

	get viewGenPropsMgr(): IWindowDynGenParamMgr | null {
		if (this.view && this.view.genFrame && this.view.genFrame.contentWindow)
			return (this.view.genFrame.contentWindow as IWindowDynGen & IWindowDynGenParam)._genPropsMgr;
		return null;
	}

	_initialize(init: ODynGenParamInit) {
		this.config = init;
		this.reg = this.findReg(init);

		this.view = new DynGen().initialize(Object.assign({
			reg: this.reg,
			w: this.reg.env.wsp.code,
			autoResize: true,
		} as ODynGenInit, this.config));

		this.view.tabIndex = -1;

		this.view.genFrame.addEventListener("load", () => {
			this._refreshUi();
		});

		this._attach(this.localName, init, this.view);
		this._initializeForm(init);
		//this.refresh();
	}

	protected _refreshUi(forceDisabled?: boolean) {
		if (this.viewGenPropsMgr)
			this.viewGenPropsMgr.refresh(this._lastProps, forceDisabled ? true : this.disabled, false);
		this._refreshValidity()
	}


	visitViews(visitor: (view: IView) => any): any {
		if (this.view) return visitor(this.view);
	}

	visitViewsAsync(visitor: (view: IView) => Promise<any>, options?: OViewVisitOptions): Promise<any> {
		return this.view ? visitor(this.view) : Promise.resolve(undefined);
	}

	fillJson(parent: any, root: any): void {
		Object.assign(parent, this.viewGenPropsMgr?.get() || {});
	}

	protected _lastProps: Dict<any> = null

	extractJson(parent: Dict<any>): boolean {
		this._lastProps = parent;
		this.view?.load();
		return true;
	}

	/** Form */
	formDisabledCallback(disabled: boolean) {
		this._refreshUi(disabled);
	}

	protected _refreshValidity() {
		let validity = this.viewGenPropsMgr?.checkValidity();
		this.setValidity({badInput: !validity}, validity ? "" : "Valeur incorrecte", this.view);
	}

}

REG.reg.registerSkin("wsp-generator-params-dyngen", 1, /* language=CSS */ `
	:host {
		display: flex;
		min-height: 0;
		min-width: 0;
		flex: 1;
		flex-direction: column;
	}

	wsp-dyngen {
		width: 100%;
		height: 100%;
	}


	wsp-dyngen:focus {
		outline: var(--focus-outline);
	}
`);

customElements.define("wsp-generator-params-dyngen", DynGenParam);